import config from '../config';

export const buildTitle = (title, city) => {
  return `${title ? `${title} - ` : ''}${city ? `${city.name} - ` : ''}${config().universal.siteName}`;
};
